import { Component } from "@angular/core";

@Component({
  selector: "astrobin-read-only-mode",
  templateUrl: "./read-only-mode.component.html"
})
export class ReadOnlyModeComponent {}
